// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const toggleAccordions = isExpanded => ({
    isExpanded,
    type: actions.TOGGLE_PRODUCT_DETAILS_ACCORDIONS
});

export const toggleAccordion = (accordionName, isExpanded) => ({
    accordionName,
    isExpanded,
    type: actions.TOGGLE_PRODUCT_DETAILS_ACCORDION
});



// WEBPACK FOOTER //
// ./src/product/details/action-creators/accordions.js